import { ICategoryListResponse, ICategorySummaryResponse } from '../../interfaces/categories.interface'

export interface CategoriesStateModel {
  response: ICategorySummaryResponse
  listResponse: ICategoryListResponse
}
